import styled from "styled-components";

export const DiscoveryBody = styled.div`
    overflow: visible;
    min-height: 600px;
`;
